import React from "react";

export const Placeholder: React.FC<{ children: string }> = ({ children }) => (
  <code
    translate="no"
    className="inline-block max-w-full bg-blue-50 text-blue-700 text-xs font-mono px-2 py-0.5 rounded border border-blue-200 break-all"
  >
    {children}
  </code>
);

export const VarRow: React.FC<{
  placeholder: string;
  description: React.ReactNode;
  example?: React.ReactNode;
  descriptionLabel?: string;
  exampleLabel?: string;
  stackLabels?: boolean;
}> = ({
  placeholder,
  description,
  example,
  descriptionLabel,
  exampleLabel,
  stackLabels = false,
}) => {
  if (stackLabels) {
    return (
      <div className="py-3 border-b border-gray-100 last:border-0 text-sm">
        <div className="mb-2">
          <Placeholder>{placeholder}</Placeholder>
        </div>
        <div className="space-y-2">
          <div>
            {descriptionLabel && (
              <div className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-0.5">
                {descriptionLabel}
              </div>
            )}
            <div className="text-gray-700">{description}</div>
          </div>
          {example !== undefined && (
            <div>
              {exampleLabel && (
                <div className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-0.5">
                  {exampleLabel}
                </div>
              )}
              <div className="text-gray-500 italic break-words">{example}</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="py-3 border-b border-gray-100 last:border-0">
      <div className="mb-2">
        <Placeholder>{placeholder}</Placeholder>
      </div>
      <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-sm">
        {descriptionLabel && (
          <dt className="text-xs font-medium text-gray-400 uppercase tracking-wide self-center">
            {descriptionLabel}
          </dt>
        )}
        <dd className={`text-gray-700 ${descriptionLabel ? "" : "col-span-2"}`}>
          {description}
        </dd>
        {example !== undefined && (
          <>
            {exampleLabel && (
              <dt className="text-xs font-medium text-gray-400 uppercase tracking-wide self-center">
                {exampleLabel}
              </dt>
            )}
            <dd
              className={`text-gray-500 italic break-words ${
                exampleLabel ? "" : "col-span-2"
              }`}
            >
              {example}
            </dd>
          </>
        )}
      </dl>
    </div>
  );
};

export const VarList: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="divide-y divide-gray-100 border-t border-gray-100">
    {children}
  </div>
);
